import { type FC } from 'react';

import { specContractList } from '@/common/constants/contract';
import { selectSortedExpiredSpecContract } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ExpiredContractItem } from '../ExpiredContractItem/ExpiredContractItem';

const ExpiredSpecContractList: FC = () => {
  const isFirstVisit = useAppSelector((state) => state.user.isFirstVisit);
  const list = useAppSelector((state) =>
    selectSortedExpiredSpecContract(state, specContractList),
  );

  return (
    !isFirstVisit &&
    list.map((contract) => (
      <ExpiredContractItem key={contract.id} {...contract} />
    ))
  );
};

export { ExpiredSpecContractList };
